import { H1, P } from '@dnb/eufemia';
import Markdown from '@portals/shared-frontend/components/Markdown';
import { OpenAPIV3 } from 'openapi-types';
import { Fragment, memo } from 'react';

import {
  DereferencedComponentsObject,
  DereferencedPathsObject,
  TagType,
} from '@/pages/api-documentation/constants/types';
import { PathItems } from '@/pages/api-documentation/sections/reference/components/ReferenceView/components/PathItems';
import SecuritySchema from '@/pages/api-documentation/sections/reference/components/ReferenceView/components/SecuritySchema';

interface Props {
  info: OpenAPIV3.InfoObject;
  paths: DereferencedPathsObject;
  components: DereferencedComponentsObject | undefined;
  security: OpenAPIV3.SecurityRequirementObject[] | undefined;
  servers: OpenAPIV3.ServerObject[] | undefined;
  tags: TagType[] | undefined;
  compact: boolean;
  hasOperationsWithoutTag: boolean;
}

export const ReferenceContentView = memo(function ReferenceContentView({
  info,
  paths,
  components,
  security,
  servers,
  tags,
  compact,
  hasOperationsWithoutTag,
}: Props) {
  return (
    <div className="content">
      {info?.description && (
        <section id="introduction">
          <Markdown>{info.description}</Markdown>
        </section>
      )}
      {components?.securitySchemes && <SecuritySchema data={components.securitySchemes} />}

      {tags?.map((link) => (
        <Fragment key={`tags/${link.href}`}>
          <H1 id={`tags/${link.href}`}>{link.name}</H1>
          {link.description && <Markdown>{link.description}</Markdown>}

          <PathItems
            compact={compact}
            paths={paths}
            security={{
              security: security,
              schemas: components?.securitySchemes,
            }}
            servers={servers}
            tagName={link.name}
          />
        </Fragment>
      ))}

      {hasOperationsWithoutTag && (
        <>
          <H1 className="text-black-55">No tags</H1>
          <P>Operations without any associated tags.</P>

          <PathItems
            compact={compact}
            paths={paths}
            security={{
              security: security,
              schemas: components?.securitySchemes,
            }}
            servers={servers}
            tagName={null}
          />
        </>
      )}
    </div>
  );
});
